import { CreateFolder, UpdateFolder } from "domain/entities/folders.entities";
import { createAppAsyncThunk } from "domain/store.thunk";

export const getFolders = createAppAsyncThunk(
  "folders/getFolders",
  async (_, { extra: { foldersGateway } }) => {
    return await foldersGateway.getFolders();
  }
);

export const createFolder = createAppAsyncThunk(
  "folders/createFolder",
  async (folder: CreateFolder, { extra: { foldersGateway } }) => {
    return await foldersGateway.createFolder(folder);
  }
);

export const updateFolder = createAppAsyncThunk(
  "folders/updateFolder",
  async (folder: UpdateFolder, { extra: { foldersGateway } }) => {
    return await foldersGateway.updateFolder(folder);
  }
);

export const getFolderSeances = createAppAsyncThunk(
  "folders/getFolderSeances",
  async (folderId: number, { extra: { foldersGateway } }) => {
    return await foldersGateway.getFolderSeances(folderId);
  }
);

export const deleteFolder = createAppAsyncThunk(
  "folders/deleteFolder",
  async (folderId: number, { extra: { foldersGateway } }) => {
    const { success } = await foldersGateway.deleteFolder(folderId);
    return { success, folderId };
  }
);

export const addSeanceToFolder = createAppAsyncThunk(
  "folders/addSeanceToFolder",
  async (
    body: {
      folderId: number;
      seanceId: number;
    },
    { extra: { foldersGateway } }
  ) => {
    return await foldersGateway.addSeanceToFolder(body);
  }
);

export const removeSeanceFromFolder = createAppAsyncThunk(
  "folders/removeSeanceFromFolder",
  async (
    body: {
      folderId: number;
      folderSeanceId: number;
    },
    { extra: { foldersGateway } }
  ) => {
    const { success } = await foldersGateway.removeSeanceFromFolder(body);
    return { success, folderSeanceId: body.folderSeanceId };
  }
);
